/* eslint-disable no-console */
import {
  APPLE_PAY_VERSION_NUMBER,
  CURRENCY_CODE,
  PaymentStatusApplePay,
  PaymentStatus,
} from 'constants/';
import type {
  ApplePayPaymentRequest,
  PaymentRequest,
  SendPayMethodType,
  ValidateMerchantResponse,
} from 'types';

const getPaymentRequest = ({
  currencyCode,
  label,
  amount,
}: PaymentRequest): ApplePayPaymentRequest => {
  const paymentRequest: ApplePayPaymentRequest = {
    currencyCode,
    countryCode: 'KZ',
    total: {
      label,
      type: 'final',
      amount,
    },
    supportedNetworks: ['masterCard', 'visa'],
    merchantCapabilities: ['supports3DS'],
  };

  return paymentRequest;
};

const performPayment = (
  ID: string,
  sendPayMethod: SendPayMethodType,
  acquiringID: string,
  amount: string,
  fullAmount: string,
  getMerchantValidation: (validationURL: string) => Promise<ValidateMerchantResponse>,
  currencyCode: string = CURRENCY_CODE,
): Promise<number> => {
  return new Promise((resolve, reject) => {
    const session = new ApplePaySession(
      APPLE_PAY_VERSION_NUMBER,
      getPaymentRequest({ currencyCode, label: 'Payment Highway', amount }),
    );

    session.onvalidatemerchant = async (event) => {
      try {
        const merchantSession = await getMerchantValidation(event.validationURL);
        session.completeMerchantValidation(merchantSession);
      } catch (err) {
        console.error('Validate error', JSON.stringify(err));
        session.abort();
        reject(new Error(PaymentStatusApplePay.FAILURE.toString()));
      }
    };

    session.onpaymentauthorized = async (event) => {
      try {
        const response = await sendPayMethod({
          ID,
          acquiringID,
          amount: fullAmount,
          payData: null,
          applepay: JSON.stringify(event.payment.token),
        });

        console.log('onpaymentauthorized response', response);

        if (
          response.status === PaymentStatus.WAIT_PROCESSING ||
          response.status === PaymentStatus.WAIT_PAYMENT_CONFIRM ||
          response.status === PaymentStatus.HOLDED ||
          response.status === PaymentStatus.PAYMENT_SUCCESS
        ) {
          session.completePayment(ApplePaySession.STATUS_SUCCESS);
          resolve(PaymentStatusApplePay.SUCCESS);
        } else {
          console.error('Payment error in response', JSON.stringify(response));
          session.completePayment(ApplePaySession.STATUS_FAILURE);
          reject(new Error(PaymentStatusApplePay.FAILURE.toString()));
        }
      } catch (err) {
        console.error('Payment error', JSON.stringify(err));
        session.completePayment(ApplePaySession.STATUS_FAILURE);
        reject(new Error(PaymentStatusApplePay.FAILURE.toString()));
      }
    };

    session.oncancel = () => {
      console.log('Session cancelled');
      reject(new Error(PaymentStatusApplePay.CANCEL.toString()));
    };

    session.begin();
  });
};

export { performPayment };
